import React, {useEffect, useState} from "react"
import './blogPage.css'

import {useParams} from "react-router-dom"
import {Link} from "react-router-dom"
import {blogData} from "../../Data"
import {RxDoubleArrowLeft, RxDoubleArrowRight} from "react-icons/rx"
import Aos from "aos"
import 'aos/dist/aos.css'

const BlogPage = () => {
    const [postData, setPostData] = useState({prevPath: '/', nextPath: '/'})

    let { post } = useParams()

    useEffect(() => {
        Aos.init({duration:1500})
        setPostDataBasedOnPath()
    }, [post])

    const setPostDataBasedOnPath = () => {
        if (post === 'aboutSketch') {
            setPostData(({...blogData[0]}))
        }
        if (post === 'sketchTypes') {
            setPostData(({...blogData[1]}))
        }
        if (post === 'sketchForDesigners') {
            setPostData(({...blogData[2]}))
        }
        if (post === 'editsTypes') {
            setPostData(({...blogData[3]}))
        }
        if (post === 'japandiStyle') {
            setPostData(({...blogData[4]}))
        }
        if (post === 'procreateTips') {
            setPostData(({...blogData[5]}))
        }
        if (post === 'architecturalSketch') {
            setPostData(({...blogData[6]}))
        }
        if (post === 'popularQuestion') {
            setPostData(({...blogData[7]}))
        }
    }

    return (
        <>
            <section id='blogPage'>
                <div className="blogpage_title">
                    <p className="eyebrow">Journal · {postData.datePublished}</p>
                    <h1>{postData.title}</h1>
                </div>
                <div className='container'>
                    <div className='blogpage_header'>
                        {postData.prevPath ? <Link to={postData.prevPath} className="btn-blog"><RxDoubleArrowLeft className='blogpage_icon'/><span><small>Previous</small>Article</span></Link> : <span className="btn-blog disabled" />}
                        <Link to="/blog/overview" className="back_to_journal">All articles</Link>
                        {postData.nextPath ? <Link to={postData.nextPath} className="btn-blog"><span><small>Next</small>Article</span><RxDoubleArrowRight className='blogpage_icon'/></Link> : <span className="btn-blog disabled" />}
                    </div>
                    <div data-aos='zoom-in' data-aos-duration='2000' className='blogpage_container'>
                        <div className='blogpage_image'>
                            <img src={postData.img} alt={postData.title} loading="lazy" decoding="async"/>
                        </div>
                        <div className='blogpage_content'>
                            <div className='blogpage_text'>
                                {(postData.description || '').split(/\n\n+/).map((paragraph, index) => <p key={index}>{paragraph}</p>)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogPage
